var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.corectHeah.topic))]),_vm._v(" "),_c('span',[_vm._v("总人数："+_vm._s(_vm.totalcount))]),_vm._v(" "),_c('span',{attrs:{"id":"span1"}},[_vm._v("无成绩人数："+_vm._s(_vm.noperformance))]),_vm._v(" "),_c('div',{attrs:{"id":"main"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6100fe4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/teacher/ViewExcelEcharts.vue
// module id = null
// module chunks = 